import { render, staticRenderFns } from "./guests-info.vue?vue&type=template&id=0b77b11f&scoped=true"
import script from "./guests-info.vue?vue&type=script&lang=js"
export * from "./guests-info.vue?vue&type=script&lang=js"
import style0 from "./guests-info.vue?vue&type=style&index=0&id=0b77b11f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77b11f",
  null
  
)

export default component.exports